import React, { useState } from 'react';
export interface BankLogoProps {
  bankName: string;
  logoUrl?: string;
  size?: 'sm' | 'md' | 'lg';
}
export function BankLogo({
  bankName,
  logoUrl,
  size = 'md'
}: BankLogoProps) {
  const [imageError, setImageError] = useState(false);
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };
  const logoSizes = {
    sm: 'max-w-[24px] max-h-[24px]',
    md: 'max-w-[40px] max-h-[40px]',
    lg: 'max-w-[56px] max-h-[56px]'
  };
  // Fallback to colored circle with initials if no logo provided or error
  const initials = bankName.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2);
  const colors = ['bg-blue-600', 'bg-red-600', 'bg-emerald-600', 'bg-purple-600', 'bg-orange-600'];
  const colorIndex = bankName.length % colors.length;
  if (logoUrl && !imageError) {
    return <div className={`${sizes[size]} rounded-xl overflow-hidden bg-white border border-gray-100 flex items-center justify-center p-2 shadow-sm flex-shrink-0`} data-id="element-1518">
        <img src={logoUrl} alt={`${bankName} logo`} className={`${logoSizes[size]} object-contain w-full h-full`} onError={() => setImageError(true)} data-id="element-1519" />
      </div>;
  }
  return <div className={`${sizes[size]} rounded-xl ${colors[colorIndex]} flex items-center justify-center text-white font-bold shadow-sm flex-shrink-0 ${size === 'sm' ? 'text-xs' : size === 'md' ? 'text-sm' : 'text-base'}`} data-id="element-1520">
      {initials}
    </div>;
}